import { render, staticRenderFns } from "./Jtopo.vue?vue&type=template&id=c8fa6d8c&scoped=true"
import script from "./Jtopo.vue?vue&type=script&lang=js"
export * from "./Jtopo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fa6d8c",
  null
  
)

export default component.exports